import EvalComAtleta from "pages/LandingPages/EvalComAtleta/evalComAtleta";

export default function EvalComAtletaPage() {
  return <EvalComAtleta />;
}
